import { useContext, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { toast } from '../../../utils'

import { StoresContext } from '../../../provider/StoreProvider'

import useParamId from '../../../hooks/useParamId'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { DivideLine } from '../../../components/divide'
import { Header } from '../../../components/header'
import { ArtipioContentsHeader, ArtipioContents, ArtipioContentItem } from '../../../components/contents'
import { DetailContent } from '../../../components/pagingList'

export const DisclosureDetail = observer(() => {
  const { commonStore, notificationStore } = useContext(StoresContext)
  const detailStore = notificationStore.disclosureDetailStore

  const paramId = useParamId()

  useEffect(() => {
    commonStore.setShowTab(false)
    return () => {
      detailStore.clearAll()
    }
  }, [])

  useEffect(() => {
    if (typeof paramId === 'undefined') return

    try {
      const loadData = async () => {
        await detailStore.load({ param: { id: paramId } }, true)
      }
      loadData()
    } catch (error) {
      toast('페이지를 불러오는데 실패했습니다.', error)
    }
  }, [paramId])

  return (
    <Wrap>
      <Header type="SUB" title="" />
      <StyledContent
        isLastImg={
          detailStore.content?.contents?.[(detailStore.content?.contents?.length as number) - 1]?.type === 'image'
        }
      >
        <DetailContent detailStore={detailStore}>
          <ArtipioContentsHeader>
            <ArtipioContentsHeader.Title>{detailStore.content?.title ?? '-'}</ArtipioContentsHeader.Title>
            <ArtipioContentsHeader.Date>
              {dayjs(new Date(detailStore.content?.createdDate ?? '-')).format('YYYY.MM.DD')}
            </ArtipioContentsHeader.Date>
          </ArtipioContentsHeader>
          <DivideLine isShort={true} space={24} />
          <ArtipioContents>
            {detailStore.content?.contents?.map(({ type, content, prop }, i) => {
              const isFirstImg = type === 'image' && i === 0
              const isLastImg = type === 'image' && i === Number(detailStore.content?.contents?.length) - 1
              return (
                <ArtipioContentItem
                  key={i}
                  type={type}
                  content={content}
                  prop={prop}
                  alt={detailStore.content?.title}
                  isFirstImg={isFirstImg}
                  isLastImg={isLastImg}
                />
              )
            })}
          </ArtipioContents>
        </DetailContent>
      </StyledContent>
    </Wrap>
  )
})

const StyledContent = styled(Content)<{ isLastImg: boolean }>`
  ${({ isLastImg }) => (isLastImg ? '' : 'padding-bottom: 108px;')}
`
